module.exports = __webpack_public_path__ + "static/media/wizards.faa731b4.svg";